import Vue from 'vue'
import App from './App.vue'

// 引入Bootstrap-vue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//引入 swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
// import 'swiper/css/swiper.min.css';
// import EasySlider from "vue-easy-slider";
// Vue.use(VueAwesomeSwiper)
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(EasySlider)
Vue.use(Element)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')